import styled from 'styled-components';
const initBack = require('../../../../../assets/img/coupon_setting_nodata.png');
const dataBack = require('../../../../../assets/img/coupon_setting_data.png');

const FocusedCouponStyled = styled.div`
  height: 100%;
  /* padding-top: 32px; */
  display: flex;
  flex-direction: column;

  .card_wrapper {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    gap: 32px;
  }

  .card_item {
    width: 382px;
    height: 140px;
    display: flex;
    padding: 24px;
    padding-right: 10px;
    /* justify-content: center; */
    /* align-items: center; */
    background: url(${dataBack}) 0 0 no-repeat;
    background-size: cover;
  }
  .addRule {
    width: 382px;
    height: 140px;
    display: flex;
    padding: 24px;
    padding-right: 10px;
    /* justify-content: center; */
    /* align-items: center; */
    background: url(${initBack}) 0 0 no-repeat;
    background-size: cover;
  }
  .button_container {
    .exit {
      margin-left: 16px;
    }
  }
`;
export default FocusedCouponStyled;
